import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import branches from '../branches.json';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, error, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { branch } = useParams();

  // Branch slug-to-label mapping
  const branchLabels = {
    aljumbo1: 'Al Jumbo 1',
    aljumbo2: 'Al Jumbo 2',
    aljumbo3: 'Al Jumbo 3',
    aljumboalrai: 'Al Jumbo Al Rai',
    doorservice: 'Door Service',
    doorservice2: 'Door Service 2',
    goldenhouse: 'Golden House',
    warehouse: 'Warehouse',
  };
  const getBranchDisplayName = (branch) => {
    if (!branch) return '';
    return branchLabels[branch] || branch;
  };

  useEffect(() => {
    console.log('Login.js user changed:', user);
    if (user) {
      navigate(`/${branch}`);
    }
  }, [user, navigate, branch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password, branch);
    } catch (err) {
      // handle error
    } finally {
      setLoading(false);
    }
  };

  if (!branches[branch]) {
    return <div>Invalid branch. Please check your login link.</div>;
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-6 col-lg-4">
        <div className="card shadow">
          <div className="card-body">
            <div className="text-center mb-4">
              <img src="/logo.png" alt="AJC Logo" style={{ maxHeight: '100px' }} className="mb-3" />
              <div className="mb-2 text-muted" style={{letterSpacing: '1px', fontSize: '1.1rem'}}>Welcome! Please log in to continue.</div>
            </div>
            
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="username" className="form-label">Username</label>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
